/* Pon Pon component bundle data model. Configuration is supplied by the inventory Worker. */
(function(global) {
  'use strict';

  var V2_SCHEMA = 'v2';
  var V2_SYSTEM = 'components-v2';
  var DEFAULT_CONFIG = {
    version: 'legacy-2026-07-21',
    state: 'active',
    system: 'components-v1',
    featureFlag: 'ponpon_bundle_system',
    updatingMessage: 'Bundle builder is currently updating. Please try again in a moment.',
    legacyBundleProductId: 8443599683684,
    flavors: [
      {
        key: 'strawberry',
        title: 'strawberry milk',
        description: 'Made with freeze-dried strawberries and blended smooth for that creamy classic taste of strawberry milk.',
        variantId: 45191806255204,
        imageUrl: 'https://cdn.shopify.com/s/files/1/0632/6894/6020/files/strawberry_final_2.png?v=1739601850',
        slotBorderColor: '#F9BEB1',
        slotBackgroundColor: '#FFF5F3'
      },
      {
        key: 'matcha',
        title: 'matcha latte',
        description: 'Indulge in the perfect balance of bold matcha and silky latte flavor, crafted with high quality culinary grade matcha.',
        variantId: 42996693467236,
        imageUrl: 'https://cdn.shopify.com/s/files/1/0632/6894/6020/files/Match_final.png?v=1739601850',
        slotBorderColor: '#B8D078',
        slotBackgroundColor: '#F5F8EC'
      }
    ],
    tiers: [
      { packCount: 1, parentVariantId: 47983826927716, priceCents: 2999 },
      { packCount: 2, parentVariantId: 47983826960484, priceCents: 5499 },
      { packCount: 4, parentVariantId: 47983826993252, priceCents: 9950 }
    ]
  };
  var config = normalizeConfig(DEFAULT_CONFIG);

  function integer(value) {
    var parsed = Number.parseInt(String(value), 10);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function discountAllocationCents(value) {
    if (typeof value === 'number') return Math.round(value);
    var normalized = String(value == null ? '' : value);
    if (!normalized) return 0;
    return normalized.indexOf('.') === -1
      ? integer(normalized)
      : Math.round(Number(normalized) * 100) || 0;
  }

  function customerCodeDiscountCents(item) {
    return (item.discount_allocations || []).reduce(function(total, allocation) {
      var application = allocation && allocation.discount_application || {};
      if (application.type !== 'discount_code') return total;
      return total + discountAllocationCents(allocation.amount);
    }, 0);
  }

  function numericId(value) {
    var parts = String(value || '').split('/');
    return integer(parts[parts.length - 1]);
  }

  function normalizeConfig(raw) {
    raw = raw || DEFAULT_CONFIG;
    var flavors = (raw.flavors || []).filter(function(flavor) { return flavor.enabled !== false; }).map(function(flavor) {
      return Object.assign({}, flavor, { variantId: numericId(flavor.variantId) });
    });
    var tiers = (raw.tiers || []).map(function(tier) {
      return Object.assign({}, tier, {
        packCount: integer(tier.packCount),
        parentVariantId: numericId(tier.parentVariantId),
        priceCents: integer(tier.priceCents)
      });
    });
    return Object.freeze(Object.assign({}, DEFAULT_CONFIG, raw, {
      flavors: Object.freeze(flavors),
      tiers: Object.freeze(tiers)
    }));
  }

  function setConfig(raw) {
    config = normalizeConfig(raw);
    return config;
  }

  function tierForPack(packCount) {
    return config.tiers.find(function(tier) { return tier.packCount === integer(packCount); });
  }

  function flavorForVariant(variantId) {
    return config.flavors.find(function(flavor) { return flavor.variantId === numericId(variantId); });
  }

  function quantitiesFrom(selection) {
    var quantities = Object.assign({}, selection.quantities || {});
    config.flavors.forEach(function(flavor) {
      if (quantities[flavor.key] == null && selection[flavor.key] != null) {
        quantities[flavor.key] = selection[flavor.key];
      }
    });
    return quantities;
  }

  function resolveCartMode(candidateConfig) {
    var system = candidateConfig && candidateConfig.system;
    return {
      system: system,
      componentMode: system === 'components-v1',
      parentLineMode: false
    };
  }

  function isEnabled() {
    return config.state === 'active' && resolveCartMode(config).componentMode;
  }

  function createBundleId() {
    if (global.crypto && typeof global.crypto.randomUUID === 'function') return 'pp-' + global.crypto.randomUUID();
    return 'pp-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }

  function buildCartItems(selection) {
    if (config.state !== 'active') throw new Error(config.updatingMessage);
    if (!resolveCartMode(config).componentMode) throw new Error(config.updatingMessage);
    var packCount = integer(selection.packCount);
    var tier = tierForPack(packCount);
    var parentVariantId = integer(selection.parentVariantId);
    var localizedExpectedPriceCents = integer(selection.expectedPriceCents);
    var quantities = quantitiesFrom(selection);
    var allowedFlavorKeys = {};
    var total = config.flavors.reduce(function(sum, flavor) {
      allowedFlavorKeys[flavor.key] = true;
      return sum + integer(quantities[flavor.key]);
    }, 0);

    if (!tier || parentVariantId !== tier.parentVariantId) throw new Error('invalid component bundle parent');
    if (Object.keys(quantities).some(function(key) {
      return !allowedFlavorKeys[key] || integer(quantities[key]) < 0;
    }) || total !== packCount) {
      throw new Error('component bundle quantities do not match the selected pack');
    }

    var bundleId = selection.bundleId || createBundleId();
    var properties = {
      _ponpon_bundle_system: config.system,
      _ponpon_bundle_id: bundleId,
      _ponpon_bundle_pack_count: String(packCount),
      _ponpon_bundle_parent_variant_id: String(parentVariantId),
      _ponpon_bundle_config_version: config.version
    };
    // This Liquid-localized presentment value is diagnostic metadata only.
    // Shopify remains the sole price authority for the component line items.
    if (localizedExpectedPriceCents > 0) {
      properties._ponpon_bundle_expected_price_cents = String(localizedExpectedPriceCents);
    }
    return config.flavors.filter(function(flavor) {
      return integer(quantities[flavor.key]) > 0;
    }).map(function(flavor) {
      return { id: flavor.variantId, quantity: integer(quantities[flavor.key]), properties: Object.assign({}, properties) };
    });
  }

  function buildParentCartItem(selection) {
    if (config.state !== 'active') throw new Error(config.updatingMessage);
    var packCount = integer(selection.packCount);
    var tier = tierForPack(packCount);
    var parentVariantId = integer(selection.parentVariantId);
    var quantities = quantitiesFrom(selection);
    var allowedKeys = {};
    var bundleSelection = {};
    var total = 0;

    config.flavors.forEach(function(flavor) {
      allowedKeys[flavor.key] = true;
      var quantity = integer(quantities[flavor.key]);
      if (quantity > 0) {
        bundleSelection[flavor.key] = quantity;
        total += quantity;
      }
    });

    if (!tier || parentVariantId !== tier.parentVariantId) throw new Error('invalid component bundle parent');
    if (Object.keys(quantities).some(function(key) {
      return !allowedKeys[key] || integer(quantities[key]) < 0;
    }) || total !== packCount) {
      throw new Error('component bundle quantities do not match the selected pack');
    }

    return {
      id: parentVariantId,
      quantity: 1,
      properties: {
        _ponpon_bundle_system: V2_SYSTEM,
        _ponpon_bundle_schema: V2_SCHEMA,
        _ponpon_bundle_selection: JSON.stringify(bundleSelection),
        _ponpon_bundle_pack_count: String(packCount),
        _ponpon_bundle_parent_variant_id: String(parentVariantId),
        _ponpon_bundle_config_version: config.version
      }
    };
  }

  function inspectCart(cart) {
    var requirements = {};
    config.flavors.forEach(function(flavor) { requirements[flavor.key] = 0; });
    var groups = {};
    var errors = [];
    var priceErrors = [];

    (cart && cart.items || []).forEach(function(item) {
      var properties = item.properties || {};
      var quantity = integer(item.quantity);
      if (properties._ponpon_bundle_system === V2_SYSTEM &&
          properties._ponpon_bundle_schema === V2_SCHEMA) {
        var v2PackCount = integer(properties._ponpon_bundle_pack_count);
        var v2ParentVariantId = integer(properties._ponpon_bundle_parent_variant_id);
        var v2Tier = tierForPack(v2PackCount);
        var v2Selection;
        try {
          v2Selection = JSON.parse(properties._ponpon_bundle_selection || '');
        } catch (_error) {
          v2Selection = null;
        }

        if (!v2Selection || Array.isArray(v2Selection) || !v2Tier || !quantity ||
            v2ParentVariantId !== v2Tier.parentVariantId ||
            integer(item.variant_id || item.id) !== v2Tier.parentVariantId ||
            properties._ponpon_bundle_config_version !== config.version) {
          errors.push('invalid v2 component bundle parent');
          return;
        }

        var expectedComponents = {};
        var v2Total = 0;
        var invalidSelection = false;
        Object.keys(v2Selection).forEach(function(key) {
          var configuredFlavor = config.flavors.find(function(flavor) {
            return flavor.key === key;
          });
          var selectedQuantity = integer(v2Selection[key]);
          if (!configuredFlavor || selectedQuantity <= 0) {
            invalidSelection = true;
            return;
          }
          expectedComponents[configuredFlavor.variantId] = selectedQuantity * quantity;
          requirements[key] += selectedQuantity * quantity;
          v2Total += selectedQuantity;
        });

        var components = item.item_components || [];
        var actualComponents = {};
        components.forEach(function(component) {
          var componentVariantId = numericId(component.variant_id || component.id);
          actualComponents[componentVariantId] =
            (actualComponents[componentVariantId] || 0) + integer(component.quantity);
        });

        var componentIds = Object.keys(expectedComponents);
        var componentsAreValid = components.length
          ? Object.keys(actualComponents).length === componentIds.length &&
            !componentIds.some(function(variantId) {
              return actualComponents[variantId] !== expectedComponents[variantId];
            })
          : item.has_components === true;
        if (invalidSelection || v2Total !== v2PackCount || !componentsAreValid) {
          errors.push('v2 component bundle is incomplete');
        }
        return;
      }

      if (Number(item.product_id) === config.legacyBundleProductId) {
        config.flavors.forEach(function(flavor) {
          var legacyName = flavor.title.replace(/\b\w/g, function(letter) { return letter.toUpperCase(); });
          requirements[flavor.key] += integer(properties[legacyName]) * quantity;
        });
        return;
      }

      var flavor = flavorForVariant(item.variant_id || item.id);
      if (properties._ponpon_bundle_system !== config.system) {
        if (flavor) errors.push('component bundle line is missing its group');
        return;
      }
      var bundleId = properties._ponpon_bundle_id;
      var packCount = integer(properties._ponpon_bundle_pack_count);
      var parentVariantId = integer(properties._ponpon_bundle_parent_variant_id);
      var expectedPriceCents = integer(properties._ponpon_bundle_expected_price_cents);
      var tier = tierForPack(packCount);
      if (!flavor || !bundleId || !tier) { errors.push('invalid component bundle line'); return; }
      if (!groups[bundleId]) groups[bundleId] = {
        id: bundleId, packCount: packCount, parentVariantId: parentVariantId,
        expectedPriceCents: expectedPriceCents, configVersion: properties._ponpon_bundle_config_version,
        quantity: 0, finalPriceCents: 0
      };
      var group = groups[bundleId];
      if (group.packCount !== packCount || group.parentVariantId !== parentVariantId ||
          (group.configVersion !== properties._ponpon_bundle_config_version)) {
        errors.push('component bundle lines disagree about their group'); return;
      }
      group.quantity += quantity;
      group.finalPriceCents +=
        integer(item.final_line_price != null ? item.final_line_price : item.line_price) +
        customerCodeDiscountCents(item);
      requirements[flavor.key] += quantity;
    });

    Object.keys(groups).forEach(function(bundleId) {
      var group = groups[bundleId];
      var tier = tierForPack(group.packCount);
      if (group.quantity !== group.packCount || !tier || group.parentVariantId !== tier.parentVariantId) errors.push('component bundle is incomplete');
      // Prices and discounts are Shopify-owned. The tier configuration is in
      // USD, while cart totals and historical display metadata may be in CAD
      // at different exchange rates. Only validate bundle structure here.
    });
    return { requirements: requirements, groups: groups, errors: errors, priceErrors: priceErrors };
  }

  global.PonPonComponentBundle = Object.freeze({
    get config() { return config; }, setConfig: setConfig, isEnabled: isEnabled,
    resolveCartMode: resolveCartMode,
    createBundleId: createBundleId, buildCartItems: buildCartItems,
    buildParentCartItem: buildParentCartItem, inspectCart: inspectCart
  });

  if (global.document && global.document.documentElement) {
    global.document.documentElement.dataset.ponponComponentBundleReady = 'true';
    global.document.documentElement.dataset.ponponComponentBundleMode = isEnabled() ? 'components-v1' : 'unavailable';
  }
})(window);
